// extracted by mini-css-extract-plugin
export default {"codeBlockWrapper":"CodeBlock_codeBlockWrapper__1ix+F"};